import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuth } from './context/AuthContext';
import Layout from './components/common/Layout';
import LoginPage from './pages/LoginPage';
import OrganizationPage from './pages/OrganizationPage';
import OutletsPage from './pages/OutletsPage';
import OutletDetailPage from './pages/OutletDetailPage';
import StaffPage from './pages/StaffPage';
import AttendancePage from './pages/AttendancePage';
import AttendanceDetailPage from './pages/AttendanceDetailPage';
import UsersPage from './pages/UsersPage';
import UserLogsPage from './pages/UserLogsPage';
import ChecklistPage from './pages/ChecklistPage';
import ChecklistDetailPage from './pages/ChecklistDetailPage';
import ChecklistStatusPage from './pages/ChecklistStatusPage';
import ChecklistManagePage from './pages/ChecklistManagePage';
import ChecklistDailyStatusPage from './pages/ChecklistDailyStatusPage';
import ChecklistDailyStatusDetailPage from './pages/ChecklistDailyStatusDetailPage';
import PerformancePage from './pages/PerformancePage';
import PerformanceDetailPage from './pages/PerformanceDetailPage';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen">Loading...</div>;
  return user ? children : <Navigate to="/login" replace />;
};

// Redirect to the most relevant landing page based on role
function DefaultRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (['organization', 'outlet_owner', 'outlet_manager'].includes(user.role)) {
    return <Navigate to="/attendance" replace />;
  }
  return <Navigate to="/organizations" replace />;
}

export default function App() {
  const { user } = useAuth();

  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<DefaultRedirect />} />
          <Route path="organizations" element={<OrganizationPage />} />
          <Route path="outlets" element={<OutletsPage />} />
          <Route path="outlets/:id" element={<OutletDetailPage />} />
          <Route path="staff" element={<StaffPage />} />
          <Route path="attendance" element={<AttendancePage />} />
          <Route path="attendance/:staffId" element={<AttendanceDetailPage />} />
          <Route path="checklist" element={<ChecklistPage />} />
          <Route path="checklist/:id" element={<ChecklistManagePage />} />
          <Route path="checklist-status" element={<ChecklistStatusPage />} />
          <Route path="checklist-status/:staffId" element={<ChecklistDetailPage />} />
          <Route path="checklist-daily-status" element={<ChecklistDailyStatusPage />} />
          <Route path="checklist-daily-status/:staffId" element={<ChecklistDailyStatusDetailPage />} />
          <Route path="performance" element={<PerformancePage />} />
          <Route path="performance/:staffId" element={<PerformanceDetailPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="logs" element={<UserLogsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
